"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppProjectStatsTypes = exports.JWTPayload = void 0;
class JWTPayload {
    constructor(userId, email, role, appName, sharingUser) {
        this.userId = userId;
        this.email = email;
        this.role = role;
        this.appName = appName;
        this.sharingUser = sharingUser;
    }
    get() {
        return {
            userId: this.userId,
            email: this.email,
            role: this.role,
            appName: this.appName,
            sharingUser: this.sharingUser,
        };
    }
}
exports.JWTPayload = JWTPayload;
exports.AppProjectStatsTypes = ['registrationType', 'appType'];
